import { ajax, forEach } from "./utils.js";

document.addEventListener("click", function (event) {
	let target = event.target;

	if (event.target.classList.contains("readMore")) {
		event.preventDefault();
		const button = target;
		let parent = button.closest(".ajaxNews");
		let targetSrc = button.dataset.target;
		let targetID = "#" + targetSrc;
		let row = document.querySelector(targetID + " .row");
		let posts = parent.querySelectorAll(".largeNews, .newsBlock");
		let posts_length = posts.length;
		let exclude = [];
		let categories = "";
		let teams = "";
		for (let i = 0; i < posts_length; i++) {
			exclude.push(posts[i].dataset.postId);
		}
		let offset = exclude.length;

		if (button.hasAttribute("data-cats")) {
			categories = button.getAttribute("data-cats");
		}
		if (button.hasAttribute("data-teams")) {
			teams = button.getAttribute("data-teams");
		}

		load_posts(targetSrc, row, offset, exclude, button, categories, teams);
	} else if (event.target.classList.contains("tabs__single")) {
		event.preventDefault();
		const tab = target;
		document.querySelector(".tabs__single.tabs__single--active").classList.remove("tabs__single--active");
		tab.classList.add("tabs__single--active");

		let targetSrc = tab.dataset.target;
		let targetID = "#" + targetSrc;
		let row = document.querySelector(targetID + " .row");
		let categories = "";
		let teams = "";

		document.querySelector(".smallNews--active").classList.remove("smallNews--active");

		target = document.querySelector(targetID);
		target.classList.add("smallNews--active");
		if (!document.querySelector(targetID).classList.contains("smallNews--loaded")) {
			let offset = 0;
			document.querySelector(targetID).classList.add("smallNews--loaded");
			if (targetSrc == "latestTags") {
				categories = tab.dataset.tags;
			}
			load_posts(targetSrc, row, offset, [], false, categories, teams);
		}
	}
});

function load_posts(type, row, offset, exclude = [], button = false, categories = [], teams = []) {
	if (button) {
		button.classList.add("readMore--hidden");
	}
	let template = button !== false && button.hasAttribute("data-template") ? button.dataset.template : false;
	let start = button !== false && button.hasAttribute("data-start") ? button.dataset.start : false;
	let end = button !== false && button.hasAttribute("data-end") ? button.dataset.end : false;

	ajax.get(
		"https://www.plbold.dk/wp-json/wp/v2/load-more/",
		{
			type,
			offset,
			exclude,
			template,
			start,
			end,
			categories,
			teams,
		},
		function (response) {
			let posts = response;
			if (template == "frontpage") {
				let wrapper = document.getElementById("homeNewsWrapper");
				wrapper.insertAdjacentHTML("beforeend", posts);
			} else {
				if (offset == 0) {
					row.innerHTML = posts;
				} else {
					row.insertAdjacentHTML("beforeend", posts);
				}
			}

			if (button) {
				let scripts = findScriptTagsAndScripts(posts);
				forEach(scripts, (script) => {
					if (script.startsWith("window.Quickwrap.cmd.push")) {
						eval(script);
					}
				});
				if (template == "frontpage") {
					button.classList.remove("readMore--hidden");
				}
				if (row) {
					let count = row.querySelectorAll(".newsBlock").length;
					if (button.dataset.total <= count) {
						button.remove();
					} else {
						button.classList.remove("readMore--hidden");
					}
				}
			}
			hide_extra_mobile_posts();
		}
	);
}

/* Load frontpage posts when scrolled on single post */
if (document.getElementById("load_front_posts")) {
	const observer = new IntersectionObserver((entries) => {
		for (const entry of entries) {
			if (entry.isIntersecting) {
				observer.unobserve(entry.target);
				load_front_posts();
			}
		}
	});

	const billboard = document.getElementById("load_front_posts");
	observer.observe(billboard);
}

function load_front_posts() {
	ajax.post("https://www.plbold.dk/wp-json/wp/v2/load-frontpage/", {}, function (response) {
		let wrapper = document.getElementById("frontAjax");
		wrapper.insertAdjacentHTML("beforeend", response);
		render_popular_widget();

		let scripts = findScriptTagsAndScripts(response);

		forEach(scripts, (script) => {
			if (script.startsWith("window.Quickwrap.cmd.push")) {
				eval(script);
			}
		});
	});
}

function render_popular_widget() {
	var widget_placeholders = document.querySelectorAll(
		".wpp-widget-placeholder, .wpp-widget-block-placeholder, .wpp-shortcode-placeholder"
	);
	var w = 0;

	while (w < widget_placeholders.length) {
		fetchWidget(widget_placeholders[w]);
		w++;
	}

	var sr = document.querySelectorAll(".popular-posts-sr");

	if (sr.length) {
		for (var s = 0; s < sr.length; s++) {
			WordPressPopularPosts.theme(sr[s]);
		}
	}

	function fetchWidget(widget_placeholder) {
		let widget_id_attr = widget_placeholder.getAttribute("data-widget-id"),
			method = "GET",
			url = "",
			headers = {
				"X-WP-Nonce": wpp_params.token,
			},
			params = "";

		if (widget_id_attr) {
			url = wpp_params.ajax_url + "/widget/" + widget_id_attr.split("-")[1];
			params = "is_single=" + wpp_params.ID + (wpp_params.lang ? "&lang=" + wpp_params.lang : "");
		} else {
			method = "POST";
			url =
				wpp_params.api_url +
				"/v2/widget?is_single=" +
				wpp_params.ID +
				(wpp_params.lang ? "&lang=" + wpp_params.lang : "");
			headers["Content-Type"] = "application/json";

			let json_tag = widget_placeholder.parentNode.querySelector('script[type="application/json"]');

			if (json_tag) {
				let args = JSON.parse(json_tag.textContent.replace(/[\n\r]/g, ""));
				params = JSON.stringify(args);
			}
		}

		WordPressPopularPosts.ajax(
			method,
			url,
			params,
			function (response) {
				renderWidget(response, widget_placeholder);
			},
			headers
		);
	}

	function renderWidget(response, widget_placeholder) {
		widget_placeholder.insertAdjacentHTML("afterend", JSON.parse(response).widget);

		let parent = widget_placeholder.parentNode,
			sr = parent.querySelector(".popular-posts-sr"),
			json_tag = parent.querySelector('script[type="application/json"]');

		if (json_tag) parent.removeChild(json_tag);

		parent.removeChild(widget_placeholder);
		parent.classList.add("wpp-ajax");

		if (sr) {
			WordPressPopularPosts.theme(sr);
		}

		let event = new Event("wpp-onload", { bubbles: true, cancelable: false });
		parent.dispatchEvent(event);
	}
}

function findScriptTagsAndScripts(htmlString) {
	const regex = /<script\b[^>]*>([\s\S]*?)<\/script\b[^>]*>/g;
	const matches = htmlString.matchAll(regex);
	const scripts = [];

	for (const match of matches) {
		const scriptContent = match[1].trim();
		if (scriptContent) {
			scripts.push(scriptContent);
		}
	}

	return scripts;
}

adjust_mobile_ui();

function adjust_mobile_ui() {
	if (document.querySelector(".newsRow")) {
		setTimeout(() => {
			hide_extra_mobile_posts();
		}, 300);

		const observer = new IntersectionObserver((entries) => {
			for (const entry of entries) {
				if (entry.isIntersecting) {
					observer.unobserve(entry.target);
					hide_extra_mobile_posts();
				}
			}
		});

		const newsRow = document.querySelector(".newsRow");
		observer.observe(newsRow);
	}
}

function hide_extra_mobile_posts() {
	let rows = document.querySelectorAll(".newsRow");

	forEach(rows, (row) => {
		let i = 0;
		let elements = row.querySelectorAll(".newsColumn--small");
		for (const element of elements) {
			if (i > 6) {
				element.classList.add("mobileHidden");
			}
			i++;
		}
	});
}

if (document.querySelector(".content__post")) {
	add_post_mobile_ads();
}

function add_post_mobile_ads() {
	const contentPostElement = document.querySelector(".content__post");
	const paragraphs = contentPostElement.querySelectorAll("p");
	const paragraph_length = paragraphs.length;

	if (paragraph_length > 0) {
		const mobile_id_2 = "div-gpt-ad-mobile_2_" + randomIntFromInterval(1, 1000);
		const mobile_id_3 = "div-gpt-ad-mobile_3_" + randomIntFromInterval(1, 1000);
		const firstParagraph = paragraphs[0];
		const additionalHTML = document.createElement("p");
		additionalHTML.innerHTML =
			"<div class='mobileSquare'><span class='annonce'>Annonce</span><div id='" + mobile_id_2 + "'></div></div>";

		contentPostElement.insertBefore(additionalHTML, firstParagraph.nextElementSibling);

		window.Quickwrap.cmd.push(function () {
			window.Quickwrap.infinity("div-gpt-ad-mobile_2", mobile_id_2);
		});

		if (paragraph_length > 1) {
			const additionalHTML2 = document.createElement("p");
			additionalHTML2.innerHTML =
				"<div class='mobileSquare'><span class='annonce'>Annonce</span><div id='" +
				mobile_id_3 +
				"'></div></div>";

			contentPostElement.insertBefore(additionalHTML2, paragraphs[paragraph_length - 1].nextElementSibling);

			window.Quickwrap.cmd.push(function () {
				window.Quickwrap.infinity("div-gpt-ad-mobile_3", mobile_id_3);
			});
		}
	}
}

function randomIntFromInterval(min, max) {
	// min and max included
	return Math.floor(Math.random() * (max - min + 1) + min);
}

// function push_notifications() {
// 	if (!document.querySelector(".wrapTitleSub__one__sub")) return;

// 	let tag_id = document.querySelector(".wrapTitleSub__one__sub").getAttribute("data-tag");

// 	window.OneSignalDeferred = window.OneSignalDeferred || [];

// 	OneSignalDeferred.push(function (OneSignal) {

// 		OneSignal.init({
// 			appId: "ff082652-9cb4-41e3-b888-de326d730f08",
// 			safari_web_id: "web.onesignal.auto.67c39979-7446-4274-a748-fcdf2406257a",
// 			notifyButton: {
// 				enable: true,
// 			},
// 			serviceWorkerParam: { scope: "/push/" },
// 			serviceWorkerPath: "push/OneSignalSDKWorker.js",
// 			promptOptions: {
// 				slidedown: {
// 					prompts: [
// 						{
// 							autoResubscribe: true,
// 							type: "category",
// 							// autoPrompt: true,
// 							text: {
// 								actionMessage: "We'd like to show you notifications for the latest news and updates.",
// 								acceptButton: "Allow",
// 								cancelButton: "Cancel",

// 								/* CATEGORY SLIDEDOWN SPECIFIC TEXT */
// 								negativeUpdateButton: "Cancel",
// 								positiveUpdateButton: "Save Preferences",
// 								updateMessage: "Update your push notification subscription preferences.",
// 							},
// 							// delay: {
// 							// 	pageViews: 0,
// 							// 	timeDelay: 0
// 							// },
// 							categories: [
// 								{
// 									tag: "180",
// 									label: "Breaking news",
// 								},
// 								{
// 									tag: "132",
// 									label: "Rygtebørsen",
// 								},
// 							],
// 						},
// 					],
// 				},
// 			},
// 		});

// 		setTimeout(() => {
// 			let current_tags = OneSignal.User.getTags();
	
// 			if (tag_id in current_tags) {
// 				document.querySelector(".wrapTitleSub__one").classList.add("wrapTitleSub__one--subbed");
// 			}else{
// 				document.querySelector(".wrapTitleSub__one").classList.add("wrapTitleSub__one--sub");
// 			}
// 		}, 1800);

// 		document.querySelector(".wrapTitleSub__one__sub").addEventListener("click", function (e) {
// 			e.preventDefault();
// 			OneSignal.User.addTag(tag_id, "1");
// 			document.querySelector(".wrapTitleSub__one").classList.add("wrapTitleSub__one--subbed");
// 			document.querySelector(".wrapTitleSub__one").classList.remove("wrapTitleSub__one--sub");
// 		});

// 		document.querySelector(".wrapTitleSub__one__unsub").addEventListener("click", function (e) {
// 			e.preventDefault();
// 			OneSignal.User.removeTag(tag_id);
// 			document.querySelector(".wrapTitleSub__one").classList.remove("wrapTitleSub__one--subbed");
// 			document.querySelector(".wrapTitleSub__one").classList.add("wrapTitleSub__one--sub");
// 		});
// 	});
// }

// push_notifications();